import axios from '../api';
import Permissions from './../mixins/PermissionsHelpers';
import Constants from '../constants';

export default {
  namespaced: true,

  state: {
    folders: [],
    currentFolder: {},
    allMembers: [],
    files: [],

    messageHeader: null,
    targetId: -1,

    upload: {
      loaded: null,
      total: null,
    },
  },

  getters: {
    folders(state) {
      return state.folders;
    },

    allMembers(state) {
      return state.allMembers;
    },

    currentFolder(state) {
      return state.currentFolder;
    },

    files(state) {
      return state.files.sort((a, b) => {
        return (new Date(b.created_at)) - (new Date(a.created_at));
      });
    },

    messageHeader(state) {
      return state.messageHeader;
    },

    targetId(state) {
      return state.targetId;
    },

    uploading(state) {
      return state.upload.loaded && state.upload.total;
    },

    uploadProgressPercent(state) {
      if (state.upload.loaded && state.upload.total) {
        return parseInt((state.upload.loaded * 100) / state.upload.total);
      } else {
        return 0;
      }
    },
  },

  mutations: {
    SET_FOLDERS(state, list) {
      state.folders = list;
    },

    SET_ALLMEMBERS(state, members) {
      state.allMembers = members;
    },

    SET_CURRENTFOLDER(state, folder) {
      state.currentFolder = folder;
    },

    SET_FILES(state, list) {
      state.files = list;
    },

    SET_MESSAGEHEADER(state, msg) {
      state.messageHeader = msg;
    },

    SET_TARGETID(state, id) {
      state.targetId = id;
    },
  },

  actions: {
    async loadFiles(context) {
      console.log('wait...loadFiles');
      const targetId = context.getters.targetId;

      return await axios
        .get('/api/file/loadFiles/' + targetId)
        .then((response) => {
          context.commit(
            'SET_FOLDERS',
            response.data.filter((f) => f.type == 'folder')
          );
          context.commit(
            'SET_FILES',
            response.data.filter((f) => f.type !== 'folder')
          );
          return response;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    async loadFolder(context, fileId) {
      await axios
        .get('api/file/' + fileId)
        .then((response) => {
          context.commit('SET_CURRENTFOLDER', response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async createNewFolder(context, folder) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_CREATE)
      ) {
        throw {
          folders: ['Vous n\'êtes pas autorisé à créer un dossier'],
        };
      }

      let idUser = context.getters.targetId;

      return await axios
        .put('/api/file/createFolder/' + idUser, folder)
        .then((response) => {
          context.dispatch('loadFiles');
          return response;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async editCurrentFolder(context, args) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_EDIT)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à éditer un dossier'],
        };
      }

      const targetId = context.getters.targetId;
      const [sourceId, destination] = args;

      return await axios
        .post(`/api/file/editFolder/${sourceId}/${targetId}`, destination)
        .then((response) => {
          context.dispatch('loadFiles');
          return response;
        })
        .catch((err) => {
          if (err.response.status == 403) {
            console.log('code status', err.response.status);
            throw {
              forbidden: ['Vous n\'êtes pas autorisé à éditer ce dossier.'],
            };
          }

          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async editCurrentFile(context, args) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_EDIT)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à éditer un fichier'],
        };
      }

      const targetId = context.getters.targetId;
      const [sourceId, destination] = args;

      return await axios
        .post(`/api/file/editFile/${sourceId}/${targetId}`, destination)
        .then((response) => {
          context.dispatch('loadFiles');
          return response;
        })
        .catch((err) => {
          if (err.response.status == 403) {
            console.log('code status', err.response.status);
            throw {
              forbidden: ['Vous n\'êtes pas autorisé à éditer ce dossier.'],
            };
          }

          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async deleteCurrentFolder(context, folder) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_DELETE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à supprimmer un dossier'],
        };
      }

      let idUser = context.getters.targetId;

      return await axios
        .delete('/api/file/deleteFolder/' + folder.id + '/' + idUser)
        .then((response) => {
          context.dispatch('loadFiles');
          return response;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async moveTheFile(context, folders) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_MOVE)
      ) {
        throw {
          folders: ['Vous n\'êtes pas autorisé à déplacer un dossier/fichier'],
        };
      }

      let idUser = context.getters.targetId;

      return await axios
        .post('/api/file/moveFile/' + folders.source.id + '/' + idUser, {
          destination: folders.destination,
        })
        .then((response) => {
          context.dispatch('loadFiles');
          return response;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async downloadFolder(context, folder) {
      let idUser = context.getters.targetId;

      return await axios({
        url: 'api/file/download/' + folder.id + '/' + idUser,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async downloadFile(context, file) {
      return await axios({
        url: 'api/file/download/' + file.id,
        method: 'GET',
        responseType: 'blob', // Important
      })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },

    async loadAllMembers(context) {
      await axios
        .get('api/file/members/loadMembers')
        .then((response) => {
          context.commit('SET_ALLMEMBERS', response.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async shareFolder(context, data) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_SHARE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à gérer le partage de dossier'],
        };
      }

      let idUser = context.getters.targetId;

      return await axios
        .post('api/file/shareFolder/' + data.folder.id + '/' + idUser, {
          toShareWithUsers: data.users,
          toShareWithRoles: data.roles,
        })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },

    async editRightsUsers(context, data) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_SHARE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à gérer le partage de dossier'],
        };
      }

      let usersToEdit = [];
      data.users.forEach((user) => {
        let userWithRights = {};
        switch (data.newRights) {
        case 'Administrateur':
          userWithRights = {
            user: user.id,
            rights: Constants.FILE_RIGHTS.ADMIN_RIGHTS,
          };
          break;
        case 'Editeur':
          userWithRights = {
            user: user.id,
            rights: Constants.FILE_RIGHTS.EDIT_RIGHTS,
          };
          break;
        case 'Lecteur':
          userWithRights = {
            user: user.id,
            rights: Constants.FILE_RIGHTS.READ_RIGHTS,
          };
          break;
        default:
          userWithRights = {
            user: user.id,
            rights: Constants.FILE_RIGHTS.READ_RIGHTS,
          };
          break;
        }
        usersToEdit.push(userWithRights);
      });

      let idUser = context.getters.targetId;

      return await axios
        .post('api/file/editRightsUsers/' + data.folder.id + '/' + idUser, {
          toShareWith: usersToEdit,
        })
        .then(async (response) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'success',
            msg: 'Les droits d\'accès de l\'utilisateur ont bien été modifiés.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          return await context.dispatch('loadFiles').then((r) => {
            return response;
          });
        })
        .catch((error) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'error',
            msg: 'Erreur lors du changement des droits.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          console.error(error);
        });
    },

    async editRightsRoles(context, data) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_SHARE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à gérer le partage de dossier'],
        };
      }

      let rolesToEdit = [];
      data.roles.forEach((role) => {
        let roleWithRights = {};
        switch (data.newRights) {
        case 'Administrateur':
          roleWithRights = {
            role: role.id,
            rights: Constants.FILE_RIGHTS.ADMIN_RIGHTS,
          };
          break;
        case 'Editeur':
          roleWithRights = {
            role: role.id,
            rights: Constants.FILE_RIGHTS.EDIT_RIGHTS,
          };
          break;
        case 'Lecteur':
          roleWithRights = {
            role: role.id,
            rights: Constants.FILE_RIGHTS.READ_RIGHTS,
          };
          break;
        default:
          roleWithRights = {
            role: role.id,
            rights: Constants.FILE_RIGHTS.READ_RIGHTS,
          };
          break;
        }
        rolesToEdit.push(roleWithRights);
      });

      let idUser = context.getters.targetId;

      return await axios
        .post('api/file/editRightsRoles/' + data.folder.id + '/' + idUser, {
          toShareWith: rolesToEdit,
        })
        .then(async (response) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'success',
            msg: 'Les droits d\'accès du groupe ont bien été modifiés.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          await context.dispatch('loadFiles').then((r) => {
            return response;
          });
        })
        .catch((error) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'error',
            msg: 'Erreur lors du changement des droits.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          console.error(error);
        });
    },

    async removeShare(context, data) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_SHARE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à gérer le partage de dossier'],
        };
      }

      let usersToRemove = [];
      data.users.forEach((user) => {
        usersToRemove.push(user.id);
      });

      let rolesToRemove = [];
      data.roles.forEach((role) => {
        rolesToRemove.push(role.id);
      });

      let idUser = context.getters.targetId;

      return await axios
        .post('api/file/removeShare/' + data.folder.id + '/' + idUser, {
          userIds: usersToRemove,
          roleIds: rolesToRemove,
        })
        .then(async (response) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'success',
            msg: 'Le partage a bien été supprimé.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          await context.dispatch('loadFiles').then((r) => {
            return response;
          });
        })
        .catch((error) => {
          context.commit('SET_MESSAGEHEADER', {
            type: 'error',
            msg: 'Erreur lors de la suppression du partage.',
          });
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', null);
          }, 3000);
          console.error(error);
        });
    },

    async addNewTempFile(context, data) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_CREATE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à ajouter de nouveau fichier'],
        };
      }

      return await axios
        .post('api/file/temp', data, {
          onUploadProgress: function ({ loaded, total }) {
            context.state.upload.total = total;
            context.state.upload.loaded = loaded;
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        })
        .finally(() => {
          context.state.upload.total = null;
          context.state.upload.loaded = null;
        });
    },

    async addNewFile(context, infos) {
      if (
        !Permissions.methods.$can(Constants.PERMISSION_DEPOT_DOCUMENTS_CREATE)
      ) {
        throw {
          forbidden: ['Vous n\'êtes pas autorisé à ajouter de nouveau fichier'],
        };
      }

      let idUser = context.getters.targetId;

      return await axios
        .put('api/file/add/' + idUser, infos)
        .then((response) => {
          context.dispatch('loadFiles');
          return response.data;
        })
        .catch((err) => {
          if (err.response.status == 403) {
            throw {
              forbidden: [
                'Vous n\'êtes pas autorisé à ajouter un fichier dans ce dossier.',
              ],
            };
          }
          console.log(err.response.data.errors);
          throw { ...err.response.data.errors };
        });
    },
  },
};
